import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useToken from '../common/helper/usetoken';

const EditorRestrictedRoutes = () => {
    const { decodedUserToken } = useToken();
    
    const decodedToken = decodedUserToken();// state to track onboarding status
    const onboardedStatus = decodedToken?.role?.toLowerCase() === ("editor") ? true : false;

    return !onboardedStatus ? <Outlet /> : <Navigate to="/shipment" />;
};

export default EditorRestrictedRoutes;
